import $ from 'jquery';
import Reactor from 'javascripts/reactive_rails';

function loadReactiveStubbedContentNode(el) {
  const $el = $(el);
  const node = $(el)?.get(0);

  if (node && node.isConnected) {
    Reactor.updateReactiveElement($el);
  }
}

export function loadReactiveStubbedContent(root) {
  $(root)
    .find('[data-reactive-stubbed-content="true"]')
    .each((i, el) => loadReactiveStubbedContentNode(el));
}

export function loadStubbedContentImmediately() {
  $(
    '[data-reactive-stubbed-content="true"][data-reactive-load-immediately="true"]'
  ).each(function () {
    loadReactiveStubbedContentNode(this);
  });
}

$(() => {
  // Load stubbed content that is visible in a tab
  $(document).on(
    'click.loadReactiveStubbedContent',
    '[data-toggle="tab"]',
    event => {
      const $target = $(event.currentTarget);
      const $tab = $($target.attr('data-target') || $target.attr('href'));

      loadReactiveStubbedContent($tab);
    }
  );

  $(document).on(
    'page:change drawer:load details:load',
    loadStubbedContentImmediately
  );
  loadStubbedContentImmediately();
});
